/**
 * The example drug set shown by "See an example analysis".
 *
 * Plain module (no `'use client'`) so it can be imported from server code,
 * API routes and scripts without producing a client reference.
 */
export const EXAMPLE_DRUG_IDS: readonly string[] = [
  '100083610', // Amlozek (Amlodipinum)
  '100033462', // Klacid (Clarithromycinum)
  '100074640', // Zocor 10 (Simvastatinum)
  '100240238', // Clatra (Bilastinum)
  '100278560', // Levetiracetam Aurovitas (Levetiracetamum)
];

const EXAMPLE_DRUG_ID_SET: ReadonlySet<string> = new Set(EXAMPLE_DRUG_IDS);

/** True when every id belongs to the example set (empty input counts as a subset). */
export function isExampleSubset(ids: readonly string[]): boolean {
  return ids.every((id) => EXAMPLE_DRUG_ID_SET.has(id));
}

/** True when the ids are exactly the example set (order-insensitive). */
export function isExactExampleSet(ids: readonly string[]): boolean {
  if (ids.length !== EXAMPLE_DRUG_IDS.length) return false;
  const set = new Set(ids);
  return EXAMPLE_DRUG_IDS.every((id) => set.has(id));
}

/** Canonical pair key — always `smallerId:largerId`. */
export function canonicalPairKey(id1: string, id2: string): string {
  return id1 < id2 ? `${id1}:${id2}` : `${id2}:${id1}`;
}
